import api from '../lib/api'

export const listBookings = (tenantId, status) =>
  api.get(`/manager/bookings/${tenantId}`, { params: status ? { status } : {} }).then(r => r.data)

export const listMonthlyBookings = (tenantId, month) =>
  api.get(`/manager/bookings/${tenantId}/monthly`, { params: { month } }).then(r => r.data)

export const createBooking = (tenantId, data) =>
  api.post(`/manager/bookings/${tenantId}`, data).then(r => r.data)

export const updateBooking = (tenantId, bookingId, data) =>
  api.patch(`/manager/bookings/${tenantId}/${bookingId}`, data).then(r => r.data)

export const updateBookingStatus = (tenantId, bookingId, status, by = 'staff') =>
  api.patch(`/manager/bookings/${tenantId}/${bookingId}/status`, { status, by }).then(r => r.data)

export const completeBooking = (tenantId, bookingId) =>
  api.post(`/manager/bookings/${tenantId}/${bookingId}/complete`).then(r => r.data)
